import React from 'react'
import './OAuth2AppUpsell.scss'
import OAuth2AppPromo from '../../../../assets/images/promo-oauth2-app.png'

export const createAppUpsellBody = (name: string, imageUrl: string): React.FC => {
  return () => {
    const initials = name.slice(0, 2).toUpperCase() || '?'
    return (
      <>
        <div className='d-flex align-items-center justify-content-center'>
          <div className='upsell-image-wrapper'>
            <img src={OAuth2AppPromo} alt='OAuth app promo' className='zocks-border-0.5 base-image object-fit-contain' />
            {imageUrl ? (
              <img src={imageUrl} alt='OAuth app logo' className='overlay-image' />
            ) : (
              <span className='overlay-image app-icon-initials-in-orbit'>{initials}</span>
            )}
          </div>
        </div>

        <div className='d-flex flex-column gap-1'>
          <h5>
            Bring your <span className='zocks-text-primary'>client intelligence</span> into tools you and your team use
          </h5>

          <div className='paragraph-medium'>Ask questions, get answers grounded in real client data without leaving the tools you already work in.</div>
        </div>
      </>
    )
  }
}
